import React from 'react'
import PropTypes from 'prop-types'

// This components adds a delay to react-motion animations.
// Taken from here https://github.com/chenglou/react-motion/issues/271

class Delay extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    initial: PropTypes.number,
    value: PropTypes.number,
    period: PropTypes.number,
  }

  static defaultProps = { period: 0 }
  state = { value: this.props.initial }

  refresh = props => {
    let { value, period } = props
    clearTimeout(this.timeoutToken)
    this.timeoutToken = setTimeout(() => {
      this.timeoutToken = null
      this.setState({ value })
    }, period)
  }

  componentWillUnmount() {
    if (this.timeoutToken) {
      clearTimeout(this.timeoutToken)
    }
  }

  componentDidMount() {
    this.refresh(this.props)
  }

  UNSAFE_componentWillReceiveProps = next => {
    this.refresh(next)
  }

  render() {
    // function-as-children
    return this.props.children(this.state.value)
  }
}

export default Delay
